import { render, staticRenderFns } from "./DeviceConfigs.vue?vue&type=template&id=1c284323&"
import script from "./DeviceConfigs.vue?vue&type=script&lang=js&"
export * from "./DeviceConfigs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports